
export class FgSaleReportRequest{
    unitId?:number;
    saleOrderId?:number;
    category?:string;
    brandId?:number;
    poNumber?:string;
}